import request from "@/utils/request";
// 立即登录
export function isLogin(data) {
  return request({
    url: `/venue-mobile-api/authentication/passwordLogin`,
    method: "get",
    params: data,
  });
}
// code登录
export function codeLogin(data) {
  return request({
    url: `/venue-mobile-api/H5/authentication/codeLogin`,
    method: "get",
    params: data,
  });
}
// 用户信息
export function getUserinfo(data) {
  return request({
    url: `/venue-mobile-api/H5/authentication/getUserinfo`,
    method: "get",
    params: data,
  });
}
// 密码修改
export function updatePassword(data) {
  return request({
    url: `/venue-mobile-api/H5/authentication/update/password`,
    method: "post",
    data,
  });
}
// 首页数据 近期预约列表
export function recentAppointmentList(params) {
  return request({
    url: `/venue-mobile-api/mobile/front/home/recentAppointmentList`,
    method: "post",
    params,
  });
}
// 首页数据 即将参加的统计
export function statisticsToBeParticipatedInSoon() {
  return request({
    url: `/venue-mobile-api/mobile/front/home/statisticsToBeParticipatedInSoon`,
    method: "post",
  });
}

// 获取会议申请信息并锁定二维码（扫码的第一时间就需要先锁定 再签到）
export function lockQRCode(params) {
  return request({
    url: `/venue-mobile-api/mobile/front/user/lockQRCode`,
    method: "post",
    params,
  });
}
// 二维码签到/签离
export function qrCodeSignIn(params) {
  return request({
    url: `/venue-mobile-api/mobile/front/user/qrCode/signIn`,
    method: "post",
    params,
  });
}
// 签到
export function signIn(params) {
  return request({
    url: `/venue-mobile-api/mobile/front/user/signIn`,
    method: "post",
    params,
  });
}
// 签离
export function signLeave(params) {
  return request({
    url: `/venue-mobile-api/mobile/front/user/leave`,
    method: "post",
    params,
  });
}
// 检查我是否签離（true已签离，false没有）
export function checkSignLeave(params) {
  return request({
    url: `/venue-mobile-api/mobile/front/user/check/My/leave`,
    method: "post",
    params,
  });
}
// 签到状态
export function checkSignIn(params) {
  return request({
    url: `/venue-mobile-api/mobile/front/user/check/My/signIn`,
    method: "post",
    params,
  });
}
// 定位签到/签离
export function clockGPS(data) {
  return request({
    url: `/venue-mobile-api/mobile/front/user/gps`,
    method: "post",
    data,
  });
}
// 获取系统一个配置
export function configGet(params) {
  return request({
    url: `/venue-mobile-api/mobile/front/config/get`,
    method: "post",
    params,
  });
}
// 文件上传
export function uploadFile(data) {
  return request({
    url: `/venue-mobile-api/file/upload`,
    method: "post",
    headers: { "Content-type": "multipart/form-data" },
    data,
  });
}
